import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import BigCar from '../game/BigCar';
import PatternCardItem from '../game/PatternCardItem';
import gameData, { GameVersions, GAME_IMAGES_KEY } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import PopOutButton from '../ui/PopOutButton';
import SelectButtonGroup from '../ui/SelectButtonGroup';
import GameScreen from './GameScreen';
import ABCyaLib from '@abcya/abcya_lib';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  constructor() {
    super({ key: IntroScreen.KEY });
  }

  init() {
    this.cameras.main.setBackgroundColor(gameData.gameVersion === GameVersions.Number ? 0x6994CD : 0x5E2B85);

    this.goBtn = null;
    this.title1 = null;
    this.title1 = null;
    this.car = null;
    this.carDriving = null;
    this.carSpeed = null;
    this.carTarget = null;
    this.introCards = null;

    this.selectTxt = null;
    this.selectBtns = null;
    this.selectShown = null;
    this.gameSelected = null;

    this.engineSound = null;

    this.config = ABCyaLib.Environment.instance.gameConfig;
  }

  create() {
    this.selectShown = false;

    this.introCards = [];
    const m = gameData.gameVersion === GameVersions.Number ? Phaser.Math.Between(1,10) : ['circle','star','triangle'];
    const startX = 300;
    const spacing = 20;
    while (this.introCards.length < 3) {
      const card = new PatternCardItem(this, gameData.gameVersion === GameVersions.Number ? m * (1 + this.introCards.length) : m[this.introCards.length]);
      card.scale = 1.3;
      card.x = startX + (this.introCards.length * (card.getBounds().width + spacing));
      card.y = this.scale.height / 2 - 20;
      card.alpha = 0;
      this.add.existing(card);
      ABCyaPhaser.Tweens.addTween(card, 300, { delay: 100 * this.introCards.length, alpha: 1 }, Phaser.Math.Easing.Linear);
      this.introCards.push(card);
    }

    const config = ABCyaLib.Environment.instance.gameConfig;

    if (config.titleGraphic === null) {
      this.title1 = ABCyaPhaser.Images.addImage(this.scale.width * 0.7, 150, 'title-1',this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
      this.title1.scaleX = 0;
      this.title1.alpha = 0;

      this.title2 = ABCyaPhaser.Images.addImage(this.scale.width * 0.7, this.title1.y + this.title1.height, 'title-2', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
      this.title2.scaleX = 0;
      this.title2.alpha = 0;
    }
    else {
      this.title1 = ABCyaPhaser.Images.addImage(this.scale.width * 0.7, 175, config.titleGraphic,this, GAME_IMAGES_KEY);
      this.title1.scaleX = 0;
      this.title1.alpha = 0;
    }

    this.goBtn = new PopOutButton(this, 'next');
    this.goBtn.x = this.scale.width / 2;
    const bottomOffset = 35;

    // to use getBounds the scale needs to be 1
    this.goBtn.scale = 1;
    this.goBtn.y = this.scale.height - (this.goBtn.getBounds().width / 2) - bottomOffset;
    this.goBtn.scale = 0;
    this.goBtn.alpha = 0;
    this.add.existing(this.goBtn);

    this.car = new BigCar(this, 'large');
    this.car.x = -this.car.getBounds().width;
    this.car.y = this.introCards[0].y - this.car.carHeight;
    this.add.existing(this.car);

    this.time.delayedCall(100, this.startIntro, null, this);
  }

  startIntro () {
    // animate title
    ABCyaPhaser.Tweens.addTween(this.title1, 1500, { delay: 500, scaleX: 1, alpha: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
    if (this.title2) ABCyaPhaser.Tweens.addTween(this.title2, 1500, { delay: 700, scaleX: 1, alpha: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);

    // drive car in
    this.time.delayedCall(500, this.startCar, null, this);

    ABCyaPhaser.Audio.playOneShot(gameData.gameVersion === GameVersions.Number ? 'number_patterns_title' : 'shape_patterns_title', this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
  }

  startCar () {
    this.carSpeed = 7;
    this.carDriving = true;
    this.playEngineSound(SoundAssetKeys._car_rev, this);
  }

  playEngineSound (soundName) {
    if (this.engineSound !== null) {
      this.engineSound.destroy();
      this.engineSound = null;
    }
    this.engineSound = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(soundName, this.engineSound);
  }

  introReady () {
    this.goBtn.popIn();
    this.goBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.startSelect, this);
  }

  startSelect () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    ABCyaPhaser.Tweens.addTween(this.title1, 1500, { delay: 500, alpha: 0, scaleX: 0, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
    if (this.title2) ABCyaPhaser.Tweens.addTween(this.title2, 1500, { delay: 700, alpha: 0, scaleX: 0, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);

    this.goBtn.popOut();

    // remove sample cards
    while (this.introCards.length > 0) {
      const c = this.introCards.shift();
      ABCyaPhaser.Tweens.addTween(c, 100, { alpha: 0 }, Phaser.Math.Easing.Linear, () => c.destroy());
    }

    // truck drive off
    ABCyaPhaser.Tweens.addTween(this.car, 200, { angle: 0, x: this.car.x + 50 }, Phaser.Math.Easing.Quadratic.Out, () => this.driveOff());
    this.playEngineSound(SoundAssetKeys._car_rev, this);
  }

  driveOff () {
    this.selectShown = true;
    this.carDriving = true;

    if (this.config.showOptions === false) {
      this.carSpeed = 12;
      this.time.delayedCall(1750, this.cleanUp, null, this);
    }
    else {
      this.carSpeed = 7;
      this.time.delayedCall(500, this.addButtons, null, this);
    }
  }

  addButtons () {
    if (this.config.showOptions === false) {
      this.goBtn = new PopOutButton(this, 'next');
      this.goBtn.x = this.scale.width / 2;
      const bottomOffset = 35;

      // to use getBounds the scale needs to be 1
      this.goBtn.scale = 1;
      this.goBtn.y = this.scale.height - (this.goBtn.getBounds().width / 2) - bottomOffset;
      this.goBtn.scale = 0;
      this.goBtn.alpha = 0;
      this.add.existing(this.goBtn);

      this.time.delayedCall(400, () => this.goBtn.popIn());
      this.goBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.cleanUp, this);
    }
    else {
      this.selectTxt = ABCyaPhaser.Text.addText(this.scale.width / 2, this.scale.height / 2 - 100, '24pt', 0xDD9E26, FontKeys.carton_sixregular, ABCyaPhaser.Localization.instance.getLocalizedString('select_a_game'), this, true).setOrigin(0.5);
      this.selectTxt.scaleX = 0;
      this.selectTxt.alpha = 0;
      ABCyaPhaser.Tweens.addTween(this.selectTxt, 700, { delay: 200, scaleX: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);

      const btnNames = ['practice','race'];
      const btnTxts = [ABCyaPhaser.Localization.instance.getLocalizedString('practice_button'),ABCyaPhaser.Localization.instance.getLocalizedString('race_button')];
      this.selectBtns = new SelectButtonGroup(this, btnNames, btnTxts);
      this.add.existing(this.selectBtns);

      this.time.delayedCall(400, () => this.selectBtns.showButtons());
      this.selectBtns.once('BTN_SELECT', this.handleBtnSelect, this);
    }
  }

  handleBtnSelect (e) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    gameData.gameMode = e._info;

    this.selectBtns.hideButtons();
    this.time.delayedCall(500, this.cleanUp, null, this);
  }

  cleanUp () {
    if (this.engineSound !== null) {
      this.engineSound.destroy();
      this.engineSound = null;
    }

    this.scene.start(GameScreen.KEY);
  }

  update () {
    // drive car here
    if (this.carDriving === true) {
      if (this.carSpeed > 0 && this.car.x > this.title1.x - (this.title1.width / 2) - this.car.getBounds().width && this.selectShown === false) {
        // reverse
        this.carSpeed *= -1;
        this.playEngineSound(SoundAssetKeys._car_crash);
      }
      else if (this.carSpeed < 0 && this.car.x < this.introCards[0].x - (this.car.getBounds().width - 80)) {
        this.carDriving = false;

        // tween to tilt down
        ABCyaPhaser.Tweens.addTween(this.car, 500, { x: this.car.x, y: this.car.y + this.car.getBounds().height, angle: -45 }, Phaser.Math.Easing.Quadratic.Out, () => this.introReady());
        this.playEngineSound(SoundAssetKeys._tire_skid_squeal08);
      }
      else {
        if (this.car.x > this.scale.width) {
          this.carDriving = false;

        }
        else {
          this.car.x += this.carSpeed;
          this.car.turnWheels(this.carSpeed);
        }
      }
    }
  }
}